var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "courseinfm_wrap", style: "height:" + _vm.height },
    [
      _c("div", { staticClass: "course_cont" }, [
        _c("div", { staticClass: "course" }, [
          _c("div", { staticClass: "course_left" }, [
            _c("img", {
              attrs: {
                src: _vm.courseParam.courseLogo
                  ? _vm.courseParam.courseLogo
                  : _vm.courseDefPic
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "course_right" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$route.query.courseName))]),
            _vm._v(" "),
            _c("div", { staticClass: "icons" }, [
              _c("div", { staticClass: "hour icons-item" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../static/images/course/teachClassIcon/classHour.png")
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("课时：" + _vm._s(_vm.courseParam.courseHour))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "business icons-item" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../static/images/course/teachClassIcon/task-sm.png")
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("任务数量：" + _vm._s(_vm.courseParam.taskNum))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("课程简介：" + _vm._s(_vm.courseMsg.courseContext))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "jobDescription" },
        _vm._l(_vm.postList, function(item, index) {
          return _c("li", { key: index }, [
            _c("div", { staticClass: "top_title" }, [
              _c("img", { attrs: { src: _vm.handleImgShow(index) } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.name))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bottom" }, [
              _c("div", { class: item.remark ? "cont" : "middle" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(item.remark ? item.remark : "暂无介绍") +
                    "\n\t\t\t\t"
                )
              ])
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", {
        staticClass: "course_detail",
        domProps: { innerHTML: _vm._s(_vm.courseMsg.detail) }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title_wrap" }, [
      _c("i"),
      _vm._v("岗位介绍\n\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title_wrap" }, [
      _c("i"),
      _vm._v("课程详情\n\t")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73071fc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73071fc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/courseInformation.vue
// module id = null
// module chunks = 